// Russian translations
const ru = {
    "nav.home": "ГЛАВНАЯ",
    "nav.settings": "НАСТРОЙКИ",
    "nav.exit": "ВЫХОД",
    "nav.inventory": "ИНВЕНТАРЬ",
    "nav.loadout": "СНАРЯЖЕНИЕ",
    "nav.play": "ИГРАТЬ",
    "nav.store": "МАГАЗИН",
    "nav.news": "НОВОСТИ",
    "nav.friends": "ДРУЗЬЯ",
    "nav.recordings": "ЗАПИСИ",
    "nav.profile": "ПРОФИЛЬ",

    "common.close": "Закрыть",
    "common.back": "Назад",
    "common.save": "Сохранить",
    "common.cancel": "Отмена",
    "common.confirm": "Подтвердить",
    "common.copy": "Копировать",
    "common.share": "Поделиться",
    "common.locked": "Заблокировано",
    "common.unavailable": "Недоступно в Бете",
    "common.beta": "БЕТА",
    "common.online": "В сети",
    "common.offline": "Не в сети",

    "lobby.status": "ГОТОВ К ВЫСАДКЕ",
    "lobby.slot_left": "Слот команды",
    "lobby.slot_right": "Слот команды",
    "lobby.slot_disabled": "Приглашения в отряд недоступны в Бета-версии.",
    "lobby.mini_status": "ОЖИДАНИЕ",

    "play.title": "РАЗВЁРТЫВАНИЕ",
    "play.subtitle": "ВЫБЕРИТЕ МИССИЮ",
    "play.mode_training": "ТРЕНИРОВКА",
    "play.mode_training_sub": "ПРОТИВ ИИ · ОФФЛАЙН",
    "play.mode_ranked": "РЕЙТИНГОВЫЙ МУЛЬТИПЛЕЕР",
    "play.mode_ranked_sub": "СОРЕВНОВАТЕЛЬНЫЙ · ОНЛАЙН",
    "play.available": "ДОСТУПНО",
    "play.beta_lock": "БЕТА БЛОК",
    "play.section_map": "КАРТА",
    "play.section_team": "РАЗМЕР КОМАНДЫ",
    "play.section_difficulty": "СЛОЖНОСТЬ БОТОВ",
    "play.deploy": "ВЫСАДКА",
    "play.last_loadout": "ПОСЛЕДНЕЕ СНАРЯЖЕНИЕ",

    "store.title": "МАГАЗИН",
    "store.subtitle": "СКИНЫ · КАПСУЛЫ · НАБОРЫ",
    "store.locked_title": "Магазин заблокирован",
    "store.locked_message": "Магазин недоступен в текущей сборке Беты.",

    "news.title": "НОВОСТИ",
    "news.subtitle": "ПАТЧ-НОУТЫ · ОБЪЯВЛЕНИЯ",

    "loadout.title": "СНАРЯЖЕНИЕ",
    "loadout.subtitle": "ОСНОВНОЕ · ВТОРИЧНОЕ · БЛИЖНИЙ БОЙ · ГРАНАТЫ",
    "loadout.slot_primary": "ОСНОВНОЕ",
    "loadout.slot_secondary": "ВТОРИЧНОЕ",
    "loadout.slot_melee": "БЛИЖНИЙ БОЙ",
    "loadout.slot_grenade": "ГРАНАТА",
    "loadout.slot_pistol_start": "СТАРТОВЫЙ ПИСТОЛЕТ",
    "loadout.save": "Сохранить снаряжение",
    "loadout.saved": "Снаряжение сохранено",

    "inventory.title": "ИНВЕНТАРЬ",
    "inventory.subtitle": "БАЛАНС ОРУЖИЯ · СКИНЫ",

    "friends.title": "ДРУЗЬЯ",
    "friends.subtitle": "СОБЕРИТЕ ОТРЯД",
    "friends.add": "Добавить друга",
    "friends.my_code": "Мой код друга",
    "friends.copy_code": "Копировать код",
    "friends.reset_code": "Сбросить код",
    "friends.incoming": "Входящие заявки",
    "friends.sent": "Отправленные заявки",
    "friends.online": "В сети",
    "friends.offline": "Не в сети",
    "friends.blocked": "Заблокированные",
    "friends.search": "Поиск",
    "friends.remove": "Удалить",
    "friends.block": "Заблокировать",
    "friends.unavailable": "Онлайн-друзья недоступны во время Беты.",

    "recordings.title": "ЗАПИСИ",
    "recordings.subtitle": "РУЧНАЯ ЗАПИСЬ КЛИПОВ",
    "recordings.start": "Начать новую запись",
    "recordings.stop": "Остановить запись",
    "recordings.mine": "Мои записи",
    "recordings.play": "Воспроизвести",
    "recordings.rename": "Переименовать",
    "recordings.delete": "Удалить",
    "recordings.download": "Скачать",
    "recordings.experimental":
        "Запись в Бете экспериментальная — используются API захвата браузера, качество может отличаться.",
    "recordings.indicator": "ЗАП",

    "exit.title": "Выйти из CROSSFIRE",
    "exit.message": "Вы уверены, что хотите выйти из CROSSFIRE?",
    "exit.confirm": "ВЫЙТИ ИЗ ИГРЫ",

    "profile.title": "ПРОФИЛЬ",
    "profile.subtitle": "ОПЕРАТОР",
    "profile.level": "УРОВЕНЬ",
    "profile.xp": "ОПЫТ",
    "profile.matches": "МАТЧИ",
    "profile.wins": "ПОБЕДЫ",
    "profile.losses": "ПОРАЖЕНИЯ",
    "profile.kills": "УБИЙСТВА",
    "profile.deaths": "СМЕРТИ",
    "profile.kd": "K/D",
    "profile.rank": "РАНГ",
    "profile.rank_beta": "БЕЗ РАНГА (БЕТА)",
    "profile.player_id": "ID ИГРОКА",
    "profile.account": "АККАУНТ",
    "profile.account_beta": "ГОСТЬ БЕТЫ",

    "settings.title": "НАСТРОЙКИ",
    "settings.tab.graphics": "Графика",
    "settings.tab.audio": "Звук",
    "settings.tab.controls": "Управление",
    "settings.tab.gameplay": "Геймплей",
    "settings.tab.language": "Язык",
};

export default ru;
